module.exports = __webpack_public_path__ + "img/5.15f928af.png";